<template>
    <div class="row">
        <div v-if="!typeDocument && ! isLegalType" class="col-12">
            <div v-if="!isTourism() && !isAccident()" class="col-12">
                <h3>Заповніть один з документів</h3>
            </div>
          <div class="form-group">
            <label for="document-type">Тип документа *</label>
            <select name="documentsList" class="custom-select documents-select mb-3"
                    id="document-type"
                    :disabled="withoutIdentificationCode && !isAccident()"
                    v-model="documentation.type">
              <option :value="documentItem.uid" v-for="documentItem in getAllowedDocumentsTypes()">{{ documentItem.name }}</option>
            </select>
          </div>
        </div>

        <div v-if="typeDocument && ! isLegalType" class="col-12">
            <div class="col-12">
                <h3>Заповніть документ</h3>
                <h5>{{ typeDocument }}</h5>
            </div>
        </div>

        <div v-if="! isLegalType" class="col-lg-6">
            <div class="form-group tooltip-group">
                <label for="documentation-serial">Серія *</label>
                <input v-if="!isDocumentBirthCertificate()"
                       key="normal-serial"
                       v-mask="getMaskType()" v-model="documentation.serial" @change="dataChenged"
                       id="documentation-serial"
                       type="text" :placeholder="getPlaceholderSerial()+'*'"
                       :class="['form-control',{invalid: ((!$v.documentation.serial.required && submitCheck) || !$v.documentation.serial.minPassportSerial) }]">
                <input v-else
                       key="birth-cert-serial"
                       v-model="documentation.serial"
                       @input="onBirthCertificateSerialInput"
                       @change="dataChenged"
                       id="documentation-serial"
                       type="text"
                       maxlength="10"
                       :placeholder="getPlaceholderSerial()+'*'"
                       :class="['form-control',{invalid: ((!$v.documentation.serial.required && submitCheck) || !$v.documentation.serial.minPassportSerial) }]">
                <i data-html="true" v-if="!typeDocument && ! isLegalType" data-placement="bottom" data-select="true"
                   data-toggle="tooltip" title="" class="icon question"
                   :data-original-title="getSeriesTitleHint()"></i>
                <small class="error"
                       v-if="!$v.documentation.serial.required && submitCheck">Введіть серію документа</small>
                <small class="error"
                       v-else-if="!$v.documentation.serial.minPassportSerial">
                    Введіть коректну серію документа
                </small>
            </div>
        </div>
        <div v-if="! isLegalType"  class="col-lg-6">
            <div class="form-group tooltip-group">
                <label for="documentation-number">Номер *</label>
                <input v-if="!isDocumentBirthCertificate()"
                       key="normal-number"
                       v-mask="getMaskSerial()" type="text" :placeholder="getPlaceholderNumber()+'*'" @change="dataChenged"
                       id="documentation-number"
                       v-model="documentation.number"
                       :class="['form-control',{invalid: ((!$v.documentation.number.required && submitCheck) || !$v.documentation.number.minPassportNumber || !$v.documentation.number.minLength)}]"
                >
                <input v-else
                       key="birth-cert-number"
                       v-mask="'######'"
                       type="text"
                       :placeholder="getPlaceholderNumber()"
                       @change="dataChenged"
                       id="documentation-number"
                       v-model="documentation.number"
                       :class="['form-control',{invalid: ((!$v.documentation.number.required && submitCheck) || !$v.documentation.number.minPassportNumber || !$v.documentation.number.minLength)}]"
                >
                <i data-html="true" v-if="!typeDocument && ! isLegalType" data-placement="bottom"
                   data-toggle="tooltip" data-select="true" title=""
                   class="icon question"
                   :data-original-title="getNumberTitleHint()"></i>
                <small class="error"
                       v-if="!$v.documentation.number.required && submitCheck">
                    Введіть номер документа</small>
                <small class="error"
                       v-else-if="!$v.documentation.number.minLength">
                    Введіть коректно номер документа</small>
                <small class="error"
                       v-else-if="!$v.documentation.number.minPassportNumber && this.documentation.type === 1">
                    Номер паспорта повинен складатися з 6 цифр
                </small>
                <small class="error"
                       v-else-if="!$v.documentation.number.minPassportNumber && this.documentation.type === 3">
                    Номер id-картки повинен складатися з 9 цифр
                </small>
                <small class="error"
                       v-else-if="!$v.documentation.number.minPassportNumber && isDocumentBirthCertificate()">
                    Номер свідоцтва повинен складатися з 6 цифр
                </small>
            </div>
        </div>

        <div v-if="! isLegalType"  class="col-lg-6">

            <div class="form-group tooltip-group">
              <label for="documentation-date-of-issue">Дата видачі *</label>
                <input v-mask="'##.##.####'" @change="dataChenged"
                       id="documentation-date-of-issue"
                       v-model="documentation.dateOfIssue"
                       placeholder="Дата видачі"
                       :class="['form-control', 'form-input_date', {invalid:
                                                                    (!$v.documentation.dateOfIssue.required && submitCheck) ||
                                                                     (!$v.documentation.dateOfIssue.customMinLength) ||
                                                                      (!$v.documentation.dateOfIssue.maxLength) ||
                                                                      (documentation.dateOfIssueError && submitCheck) ||
                                                                      (!$v.documentation.dateOfIssue.idCardNotExpired) ||
                                                                      (!$v.documentation.dateOfIssue.daysInMonth && submitCheck)}]">
                <i data-html="true" v-if="!typeDocument && ! isLegalType" data-placement="bottom"
                   data-toggle="tooltip" data-select="true" title=""
                   class="icon question"
                   :data-original-title="getDateTitleHint()"></i>
                <small class="error"
                       v-if="!$v.documentation.dateOfIssue.required && submitCheck">
                    Введіть дату видачі документа</small>
                <small class="error"
                       v-else-if="(!$v.documentation.dateOfIssue.customMinLength && submitCheck) || (!$v.documentation.dateOfIssue.maxLength && submitCheck) || (!$v.documentation.dateOfIssue.daysInMonth && submitCheck)">
                    Введіть коректно дату видачі документа</small>
                <small class="error"
                       v-else-if="(isTourism() || isDocumentBirthCertificate()) && documentation.dateOfIssueError && submitCheck">
                  Дата видачі не може бути раніше за дату народження</small>
              <small class="error"
                     v-else-if="documentation.dateOfIssueError && submitCheck">
                На момент видачі документа вам має бути більше {{ isDocumentIdCard() ? '14 років' : '16 років' }}</small>
              <small class="error"
                     v-else-if="!$v.documentation.dateOfIssue.idCardNotExpired">
                Термін дії ID-картки сплив: її видають на 10 років</small>
            </div>
        </div>

        <div v-if="! isLegalType"  class="col-lg-6">
            <div class="form-group tooltip-group">
              <label for="documentation-issued-by">Ким виданий *</label>
              <input @change="dataChenged"
                     id="documentation-issued-by"
                     v-model="documentation.issuedBy"
                     placeholder="Ким виданий"
                     :class="['form-control', 'form-input', {invalid: (!$v.documentation.issuedBy.required && submitCheck) || (!$v.documentation.issuedBy.minLength)}]">

                <i data-html="true" v-if="!typeDocument && ! isLegalType" data-placement="bottom"
                   data-toggle="tooltip" data-select="true" title=""
                   class="icon question"
                   :data-original-title="getIssuedTitleHint()"></i>
                <small class="error"
                       v-if="!$v.documentation.issuedBy.required && submitCheck">
                    Введіть ким виданий документ</small>
                <small class="error"
                       v-if="!$v.documentation.issuedBy.minLength">
                    Введіть коректно дані</small>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import {customerMixin, companyMixin, documentMixin} from "../../../mixin";
import {email, maxLength, minLength, numeric, required, requiredIf} from "vuelidate/lib/validators";

export default {
    mixins: [customerMixin, documentMixin, companyMixin],
    components: {Multiselect,VueTypeaheadBootstrap},
    props: {
        productType: {},
        offerInfo: {},
        searchInfo: {},
        documentation: {
            default: function () {
                return {
                    type: 1,//'DOCUMENT_PASSPORT'
                    serial: null,
                    number: null,
                    issuedBy: null,
                    dateOfIssue: null,
                    endDateOfIssue: null,
                    dateOfIssueError: false,
                }
            }
        },
        privileges: {
          default: function () {
              return true;
          }
        },
        submitCheck: {},
        withoutIdentificationCode: {},
        dateBirth: {}
    },
    data: function () {
        return {
            typeDocument: null,
            typeDocumentId: null,
        };
    },
    watch: {
        'documentation.type': async function( newValue, oldValue) {
            if (this.isDocumentERetireeByUid(newValue)) {
                this.documentation.serial = 'АА';//
                this.documentation.issuedBy = null;
                this.documentation.dateOfIssue = null;
            }else if (!this.isDocumentNeedEndDate(newValue)) {
                this.documentation.endDateOfIssue = null;
            }
        },
        availableDocuments: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.initSelectedDocumentType();
                }
            }
        },
        dateBirth: {
            handler() {
                this.initSelectedDocumentType();
            }
        }
    },
    created() {
        this.initSelectedDocumentType();

        let customerPrivilegeId = parseInt(this.customerPrivilege ?? 1); // TODO это не верно, потом вставлю ключ к хранилищю

        if (this.isOsago() && customerPrivilegeId !== 1 && this.privileges) {
            const privilege = this.$_.findWhere(this.privilegeList, { id: customerPrivilegeId });
            if (privilege) {
                this.typeDocument = privilege.text;
                this.typeDocumentId = privilege.documentUid;
                this.documentation.type = this.typeDocumentId;
            }
        }
    },
    computed: {
        availableDocuments() {
            //надо отсечь список доступных документов для ситуации если выбран льготный тип документа
            let available_documents = (this.offerInfo?.available_documents && this.offerInfo.available_documents.length)
                ? this.offerInfo.available_documents
                : (this.offerInfo?.allowed_documents && this.offerInfo.allowed_documents.length)
                    ? this.offerInfo.allowed_documents
                    : null;
            let customerPrivilegeId = parseInt(this.customerPrivilege ?? 1); // TODO это не верно, потом вставлю ключ к хранилищю
            if (this.isOsago() && customerPrivilegeId !== 1 && this.privileges) {
              const privilege = this.$_.findWhere(this.privilegeList, { id: customerPrivilegeId });
              if (privilege) {
                this.typeDocument = privilege.text;
                this.typeDocumentId = privilege.documentUid;
                this.documentation.type = this.typeDocumentId;
              }
            }
            return available_documents;
        },
        privilegeList() {
            return this.$store.getters.CUSTOMER_PRIVILEGE
        },
        customerPrivilege() {
            return this.offerInfo?.customerPrivilege ?? this.searchInfo.customerPrivilege ?? null;
        },
        isLegalType() {
            if (this.searchInfo?.customerType) {
                return this.searchInfo?.customerType == 2;
            } else if (this.searchInfo?.userType) {
                return this.searchInfo?.userType.id == 2;
            }
            return false;
        },
        allDocumentTypes () {
            return this.$store.getters.DOCUMENTS_TYPES
        },
        commonDocumentTypes () {
            return this.$store.getters.COMMON_DOCUMENTS_TYPES
        },
    },
    validations: {
        documentation: {
            serial: {required: requiredIf(function (nestedModel) {
                    return [1,3,5].some(data => data === Number(this.productType)) && ! this.isLegalType
                }),
                minPassportSerial(value) {
                    if (this.documentation.type == 1 && value &&  value.length < 2) {//'DOCUMENT_PASSPORT'
                        return false;
                    }else if(this.documentation.type == 3 && value &&  value.length < 14){ //'DOCUMENT_ID_CARD'
                        return false;
                    }else if(this.isDocumentBirthCertificate() && value && value.length < 3){
                        return false;
                    }

                    return true
                }
            },
            number: {required: requiredIf(function (nestedModel) {
                    return [1,3,5].some(data => data === Number(this.productType)) && ! this.isLegalType
                }),
                minLength: minLength(2),
                minPassportNumber(value) {
                    if (! this.customerHaveDocumentERetiree() && this.documentation.type == 1 && value &&  value.length < 6) {//'DOCUMENT_PASSPORT'
                        return false;
                    }else if (! this.customerHaveDocumentERetiree() && this.documentation.type == 3 && value &&  value.length < 9) {//'DOCUMENT_ID_CARD'
                        return false;
                    }else if (this.isDocumentBirthCertificate() && value && value.length < 6) {
                        return false;
                    }

                    return true
                }
            },
            issuedBy: {required: requiredIf(function (nestedModel) {
                    return (! this.checkIsEwa() &&  ! this.isLegalType) || (this.checkIsEwa() && ! this.isDocumentPassport());
                }), minLength: minLength(2)},
            endDateOfIssue: { required: requiredIf(function (nestedModel) {
                    // пока сделаем обязательно только для электронного пенсионера DOCUMENT_E_RETIREE
                    return (this.isOsago() && this.customerHaveDocumentERetiree()) || this.isDocumentERetiree(); //this.isDocumentNeedEndDate();
                }),
                maxLength: maxLength(10),
                isSameOrAfter(value) {
                    if (this.$v.documentation.endDateOfIssue.required) return true;

                    return   (this.isOsago() && ! this.customerHaveDocumentERetiree()) || moment(value, 'DD.MM.YYYY').isSameOrAfter(moment(), 'day');
                },
                customMinLength(value) {
                    if (this.$v.documentation.endDateOfIssue.required) return true;

                    return ! (value !== undefined && value !== null && value.length >= 1 && value.length < 10);
                },
            },
            dateOfIssue: {required: requiredIf(function (nestedModel) {
                    //TODO вывести это в миксин
                    if (this.checkIsEwa() && this.isDocumentPassport()) {
                        return false
                    }

                    if (this.dateBirth !== null && this.documentation.dateOfIssue !== null) {
                      if (this.isTourism() || this.isDocumentBirthCertificate()) {
                        const passportDate = moment(this.documentation.dateOfIssue, 'DD.MM.YYYY')
                        const birthDate = moment(this.dateBirth, 'DD.MM.YYYY')

                        this.documentation.dateOfIssueError = passportDate < birthDate

                        return this.documentation.dateOfIssueError
                      } else {
                        let dateIssue = parseInt(moment(this.documentation.dateOfIssue, 'DD.MM.YYYY').diff(moment(), 'years')) * -1;
                        let dateBirth = parseInt(moment(this.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years')) * -1;

                        if (this.isDocumentIdCard() && dateBirth - dateIssue < 14) {
                          this.documentation.dateOfIssueError = true;
                        }
                        else if(dateBirth - dateIssue < 14){
                          this.documentation.dateOfIssueError = true;
                        }
                        else {
                          this.documentation.dateOfIssueError = false;
                        }
                      }
                    }
                    return ! this.isLegalType

                }), maxLength: maxLength(10),
                customMinLength(value) {
                    if (this.customerHaveDocumentERetiree() || (this.checkIsEwa() && ! value)) {
                        return  true;
                    }

                    return ! (value !== null && value.length >= 1 && value.length < 10);
                },
                daysInMonth(value) {

                    if (this.isLegalType) {
                        return true;
                    }

                    if (this.customerHaveDocumentERetiree() || ((this.checkIsCredo() || this.checkIsEwa()) && ! value)) {
                        return  true;
                    }
                    return moment.duration(moment().diff(moment(value, 'DD.MM.YYYY'))).asDays() >= 0;
                },
              idCardNotExpired(value) {
                // ID-картку видають на 10 років — старша вже недійсна (ОСЦПВ)
                if (! this.isOsago() || ! this.isDocumentIdCard() || ! value || value.length < 10) {
                  return true;
                }

                return moment(value, 'DD.MM.YYYY').isSameOrAfter(moment().subtract(10, 'years'), 'day');
              },
              minDateValid(value) {
                if (this.isTourism() || this.isDocumentBirthCertificate()) {
                  const passportDate = moment(value, 'DD.MM.YYYY')
                  const birthDate = moment(this.dateBirth, 'DD.MM.YYYY')
                  this.documentation.dateOfIssueError = passportDate < birthDate

                  return passportDate >= birthDate
                }

                return true;
              }
            },
        },
    },

    methods: {
        initSelectedDocumentType() {
            if (this.documentation && this.documentation.type && typeof this.documentation.type === 'string') {
                const converted = this.convertDocumentToNumber(this.documentation.type);
                if (converted) {
                    this.documentation.type = converted;
                }
            }
            const allowed = this.getAllowedDocumentsTypes();
            if (allowed && allowed.length > 0) {
                const hasCurrent = allowed.some(d => parseInt(d.uid) === parseInt(this.documentation?.type));
                if (!this.documentation?.type || !hasCurrent) {
                    if (this.documentation) {
                        this.documentation.type = allowed[0].uid;
                    }
                }
            }
        },
        dataChenged(){
          return this.$emit('data-chenged');
        },
        getAllowedDocumentsTypes() {
            if (!this.availableDocuments || !Array.isArray(this.availableDocuments) || this.availableDocuments.length === 0) {
                return [];
            }
            let transformedDocs = this.availableDocuments.map(docId => {
                let matchingItem = this.allDocumentTypes ? this.allDocumentTypes.find(item => item.id === docId) : null;
                if(!matchingItem) return false;
                return {
                    id: matchingItem.id,
                    name: matchingItem.name,
                    uid: matchingItem.uid,
                };
            }).filter(Boolean);

            let customerPrivilegeId = parseInt(this.customerPrivilege ?? 1);
            // отфильтровывать только для обычного customer без льгот
            if (this.isOsago() && customerPrivilegeId == 1) {
                transformedDocs = transformedDocs.filter(doc => {
                    if (this.commonDocumentTypes.find(item => item.id === doc.id)) {
                        return doc;
                    }
                });
            } else if (this.isOsago() && !this.privileges) {
                transformedDocs = transformedDocs.filter(doc => {
                    if (doc.id === 'DOCUMENT_ID_CARD' || doc.id === 'DOCUMENT_PASSPORT') {
                        return doc;
                    }
                });
            } else if (this.isAccident() && this.dateBirth) {
                const birthMoment = moment(this.dateBirth, 'DD.MM.YYYY');
                if (birthMoment.isValid()) {
                    const age = moment().diff(birthMoment, 'years');
                    if (age >= 18) {
                        transformedDocs = transformedDocs.filter(doc => doc.id !== 'DOCUMENT_BIRTH_CERTIFICATE' && parseInt(doc.uid) !== 14);
                    }
                }
            }

            return transformedDocs;
        },
        isOsago() {
            return this.productType == 1;
        },
        isTourism() {
            return this.productType == 5;
        },
        isHome() {
            return this.productType == 8;
        },
        isAccident() {
            return this.productType == 12;
        },
      /**
       * @deprecated
       */
        checkIsEwa() {
            return this.isEwa(this.offerInfo?.moduleId);
        },
        checkIsCredo() {
            return this.isCredo(this.offerInfo?.moduleId);
        },
        isDocumentPassport() {
            return this.documentation.type == 1;//'DOCUMENT_PASSPORT'
        },
        isDocumentIdCard() {
            return this.documentation.type == 3;//'DOCUMENT_ID_CARD'
        },
        customerHaveDocumentERetiree() {
            return this.isDocumentERetiree(this.customerPrivilege);//this.offerInfo?.customerPrivilege
        },
        isDocumentERetiree() {
            return this.isDocumentERetireeByUid(this.documentation.type);
        },
        isDocumentNeedEndDate() {
            let itemType = this.getDocumentIdByUid(this.documentation.type);
            switch (itemType) {
                case "DOCUMENT_ID_CARD":
                    return true;
                case "DOCUMENT_E_RETIREE":
                    return true;
                case "DOCUMENT_ID_RESIDENCE_PERMIT":
                    return true;
                default:
                    return false;
            }
        },
        getMaskType() {
            if (this.typeDocument) {
                return "XXXX";
            }

            let itemType = this.getDocumentIdByUid(this.documentation.type);

            switch (itemType) {
                case "DOCUMENT_PASSPORT":
                    return "KK";
                case "DOCUMENT_ID_CARD":
                    return "########-#####";
                case "DOCUMENT_DRIVERS_LICENSE":
                  return 'MMM';
                case "DOCUMENT_EXTERNAL_PASSPORT":
                    return "NN";
                case "DOCUMENT_FOREIGN_PASSPORT":
                case "DOCUMENT_REGISTRATION_CARD":
                case "DOCUMENT_BIRTH_CERTIFICATE":
                    return "MMMM";
                case "DOCUMENT_RESIDENCE_PERMIT":
                    return "MMMM";
                case "DOCUMENT_ID_RESIDENCE_PERMIT":
                    return "MMMMMMMM-MMMMM";
                default:
                    return "XXXX";

            }
        },
        getMaskSerial() {
            if (this.typeDocument) {
                return "XXXXXXXXXXXXXXXXXXXX";
            }
            let itemType = this.getDocumentIdByUid(this.documentation.type);

            switch (itemType) {
                case "DOCUMENT_PASSPORT":
                    return "######";
                case "DOCUMENT_ID_CARD":
                    return "#########";
                case "DOCUMENT_DRIVERS_LICENSE":
                    return "######";
                case "DOCUMENT_EXTERNAL_PASSPORT":
                    return "######";
                case "DOCUMENT_FOREIGN_PASSPORT":
                    return "MMMMMMMMMMMMMMMMMMMM";
                case "DOCUMENT_RESIDENCE_PERMIT":
                    return "MMMMMMMMMMMMMMMMMMMM";
                case "DOCUMENT_BIRTH_CERTIFICATE":
                    return "######";
                default:
                    return "XXXXXXXXXXXXXXXXXXXX";
            }
        },
        isDocumentBirthCertificate() {
            let itemType = this.getDocumentIdByUid(this.documentation.type);
            return itemType === 'DOCUMENT_BIRTH_CERTIFICATE' || parseInt(this.documentation.type) === 14;
        },
        getPlaceholderSerial() {
            if (this.documentation.type === 3 ||  //'DOCUMENT_ID_CARD'
                this.documentation.type === 12  //'DOCUMENT_ID_RESIDENCE_PERMIT'
            ) {
                return 'Запис';
            }
            if (this.isDocumentBirthCertificate()) {
                return '1-БК';
            }

            return 'Серія';
        },
        getPlaceholderNumber() {
            if (this.isDocumentBirthCertificate()) {
                return '198456';
            }

            return 'Номер';
        },
        onBirthCertificateSerialInput() {
            if (this.documentation && this.documentation.serial) {
                let val = String(this.documentation.serial).toUpperCase();
                val = val.replace(/[^0-9A-ZА-ЯЁІЇЄ\-]/g, '');
                this.documentation.serial = val;
            }
        },
        getNumberTitleHint() {
            let itemType = this.getDocumentIdByUid(this.documentation.type);
            switch (itemType) {
                case "DOCUMENT_DRIVERS_LICENSE":
                    return '<img src="/images/tooltips/driver/number.jpg">';
                case "DOCUMENT_ID_CARD":
                    return '<img src="/images/tooltips/card/number.png">';
                case "DOCUMENT_FOREIGN_PASSPORT":
                    return '<img src="/images/tooltips/international/number.jpg">';
                case "DOCUMENT_RESIDENCE_PERMIT":
                    return '<img src="/images/tooltips/residence/number.jpg">';
                case "DOCUMENT_BIRTH_CERTIFICATE":
                    return 'Номер свідоцтва про народження (6 цифр, наприклад: 198456)';
                default:
                    return '<img src="/images/tooltips/passport/number.jpg">';
            }
        },
        getSeriesTitleHint() {
            let itemType = this.getDocumentIdByUid(this.documentation.type);
            switch (itemType) {
                case "DOCUMENT_DRIVERS_LICENSE":
                    return '<img src="/images/tooltips/driver/code.jpg">';
                case "DOCUMENT_ID_CARD":
                    return '<img src="/images/tooltips/card/code.png">';
                case "DOCUMENT_FOREIGN_PASSPORT":
                    return '<img src="/images/tooltips/international/code.jpg">';
                case "DOCUMENT_RESIDENCE_PERMIT":
                    return '<img src="/images/tooltips/residence/code.jpg">';
                case "DOCUMENT_BIRTH_CERTIFICATE":
                    return 'Серія свідоцтва про народження (наприклад: 1-НО або 1-БК)';
                default:
                    return '<img src="/images/tooltips/passport/code.jpg">';
            }
        },
        getDateTitleHint() {
            let itemType = this.getDocumentIdByUid(this.documentation.type);
            switch (itemType) {
                case "DOCUMENT_DRIVERS_LICENSE":
                    return '<img src="/images/tooltips/driver/date.png">';
                case "DOCUMENT_ID_CARD":
                    return '<img src="/images/tooltips/card/date.png">';
                case "DOCUMENT_FOREIGN_PASSPORT":
                    return '<img src="/images/tooltips/international/date.jpg">';
                case "DOCUMENT_RESIDENCE_PERMIT":
                    return '<img src="/images/tooltips/residence/date.jpg">';
                default:
                    return '<img src="/images/tooltips/passport/date.jpg">';
            }
        },
        getIssuedTitleHint() {
            let itemType = this.getDocumentIdByUid(this.documentation.type);
            switch (itemType) {
                case "DOCUMENT_DRIVERS_LICENSE":
                    return '<img src="/images/tooltips/driver/issue.png">';
                case "DOCUMENT_ID_CARD":
                    return '<img src="/images/tooltips/card/issue.png">';
                case "DOCUMENT_FOREIGN_PASSPORT":
                    return '<img src="/images/tooltips/international/issue.jpg">';
                case "DOCUMENT_RESIDENCE_PERMIT":
                    return '<img src="/images/tooltips/residence/issue.jpg">';
                default:
                    return '<img src="/images/tooltips/passport/issue.jpg">';
            }
        },
    }
}
</script>
<style scoped>
.form-group {
  .icon.question {
    top: 35px;
  }
  label {
    font-size: 15px;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

